import React from 'react';
import FoilSelector from '../FoilSelector/FoilSelector';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import ConditionSelector from '../ConditionSelector/ConditionSelector';
import './FiltersBar.css';

interface FiltersBarProps {
  onFiltersChange?: (filters: {
    foil: string[];
    languages: string[];
    conditions: string[];
  }) => void;
  initialFoil?: boolean;
  initialRegular?: boolean;
  initialLanguages?: string[];
  initialConditions?: string[];
}

const FiltersBar: React.FC<FiltersBarProps> = ({ 
  onFiltersChange,
  initialFoil,
  initialRegular,
  initialLanguages,
  initialConditions
}) => {
  const handleFoilChange = (foil: string[]) => {
    onFiltersChange?.({ foil, languages: [], conditions: [] });
  };

  const handleLanguageChange = (languages: string[]) => {
    onFiltersChange?.({ foil: [], languages, conditions: [] });
  };

  const handleConditionChange = (conditions: string[]) => {
    onFiltersChange?.({ foil: [], languages: [], conditions });
  };

  return (
    <div className="filters-bar">
      <FoilSelector 
        onChange={handleFoilChange} 
        initialFoil={initialFoil}
        initialRegular={initialRegular}
      />
      <LanguageSelector 
        onChange={handleLanguageChange}
        initialLanguages={initialLanguages}
      />
      <ConditionSelector 
        onChange={handleConditionChange}
        initialConditions={initialConditions}
      />
    </div>
  );
};

export default FiltersBar;
